class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll(".product-tabs__tab");

    this.tabs.forEach((tab) => {
      const tabButton = tab.querySelector(".product-tabs__tab-button");
      tabButton.addEventListener("click", () => {
        this.handleTabClick(tab);
      });
    });
  }

  handleTabClick(clickedTab) {
    if (clickedTab.classList.contains("active")) {
      clickedTab.classList.remove("active");
    } else {
      this.tabs.forEach((tab) => {
        tab.classList.remove("active");
      });

      clickedTab.classList.add("active");
    }
  }
}

customElements.define("product-tabs", ProductTabs);
